var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "dropup bl-create-attribute-dropdown" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-sm btn-default dropdown-toggle",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          title: _vm
            .$t("search.advanced.queryBuilder.attribute_create_button_title")
            .toString(),
        },
      },
      [_c("span", { staticClass: "glyphicon glyphicon-plus" }), _vm._v("​\n\t")]
    ),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "dropdown-menu" },
      _vm._l(_vm.options.operatorOptions, function (op) {
        return _c("li", { key: op.value }, [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onClick(op.value)
                },
              },
            },
            [
              _c("span", {
                staticClass: "glyphicon glyphicon-plus-sign text-success",
              }),
              _vm._v("\n\t\t\t\t" + _vm._s(op.label) + "\n\t\t\t"),
            ]
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }